import React, { useState, useEffect } from "react";
import CheckBox from "../../Buttons/CheckBox";
import TextBox from "../../Common/TextBox";

type Props = {
  id: string;
  checked: boolean;
  onClickRadio: (id: string) => void;
  label: string;
  value: number;
  onChangeValue: (value: number | string) => void;
  style?: React.CSSProperties;
  disabled?: boolean;
  minValueInclusive: number;
  maxValueInclusive?: number;
  checkBoxColorVariant?: "default" | "alternate";
};

const ToolsContentTextCheckBox = ({
  id,
  checked,
  onClickRadio,
  label,
  value,
  onChangeValue,
  style,
  disabled = false,
  minValueInclusive,
  maxValueInclusive = undefined,
  checkBoxColorVariant = "default",
}: Props) => {

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        margin: "4.5px 0px",
        ...style,
      }}
    >
      <CheckBox
        disabled={disabled}
        id={id}
        checked={checked}
        name={id}
        label={label}
        onChange={onClickRadio}
        colorVariant={checkBoxColorVariant}
        style={{
          flex: 1,
          width: 155,
          margin: "auto 0",
          fontSize: 13,
        }}
      />
      <TextBox
        name={id}
        onChange={onChangeValue}
        value={value}
        isInteger={true}
        variant="number"
        minValueInclusive = {minValueInclusive}
        maxValueInclusive = {maxValueInclusive}
        disabled={!checked || disabled}
        style={{
          height: 25,
          // background: "#FFFFFF",
          border: "1px solid #414042",
          padding: "4.25px 9px 3.54px",
          flex: 2,
        }}
      />
    </div>
  );
};

export default ToolsContentTextCheckBox;
